<script>
	import * as Yup from "yup";
	import { appProfileState } from "../../state/ApplicationState.svelte";
	import { useValidations } from "../../../../../SharedSvelte/Forms.svelte";
	import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	import { FormGroup, Input, Alert, Icon, Button } from "@sveltestrap/sveltestrap";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import Dialog from "../../../../../SharedSvelte//Dialog.svelte";

	const { validateField, validateForm, getErrors, resetErrors } = useValidations();
	let prompt;

    let formData = $state({
		newEmail: ""
	});

    let saveError = $state("");
    let errors = $derived(getErrors());
	let formHasErrors = $derived(Object.keys(errors).length ? true : false);

    const formSchema = Yup.object({
		newEmail: Yup.string()
			.required("new E-mail is required")
			.email("Invalid E-mail address"),
	});

	function handleChange(fieldName, fieldValue) {
		const vars = new Map();
		vars.set(fieldName, fieldValue);
		const data = Object.fromEntries(vars);
		for (const key in data) {
			validateField(formSchema, key, formData);
		}
	}

    function clearAllErrors() {
		resetErrors();
		saveError = "";
	}

    async function updateEmail() {
		await validateForm(formSchema, formData);
		if (formHasErrors) return;

		Loader.display();

		try {
			const response = await fetch(`${baseUrl}Security/UpdateEmail`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					__RequestVerificationToken: document.getElementsByName("__RequestVerificationToken",)[0].value,
				},
				body: JSON.stringify(formData.newEmail),
			});
			if (!response.ok) {
				const error = `Server exception: ${response.status} ${response.statusText}`;
				console.log(error);
				throw new Error();
			}

			/*const json = await response.json();
			if (!json.success) {
				console.log(json.errors);
				throw new Error(json.errors);
			}*/

			prompt.showMessage("E-mail updated successfully!<br>A verification e-mail has been sent to you.  Click on the “Verification Link” in the e-mail to finish setting things up.", "Success");
			appProfileState.securityEmail = formData.newEmail;
            formData = {};
			clearAllErrors();
			//window.scrollTo(0, 0);
		} catch (err) {
			saveError = "Failed to save new E-mail. ";
			if (err.message) saveError += err.message;
		} finally {
			Loader.hide();
		}
	}

    function handleSubmit(event) {
        event.preventDefault();
        updateEmail();
    }
</script>

<main class="mt-5 mb-2">
    <div class="card shadow" style="max-width: 600px;">
        <div class="card-body">
            <h3 class="card-title text-center mb-4">Login Account E-mail</h3>
			<p>The current E-mail associated with your login account is <strong>{appProfileState.securityEmail}</strong>.</p>
			<p>If you would like to use a different E-mail please enter the new E-mail below.</p>
            <!-- <pre>{formHasErrors} {JSON.stringify(errors)}</pre> -->
            <form onsubmit={handleSubmit}>

                <!-- New Email -->
                <div class="mb-3">
                    <FormGroup
							floating
							spacing="mb-3"
							label="New E-mail"
						>
						<Input type="email"
							bind:value={formData.newEmail}
							onchange={(e) => handleChange("newEmail", e.target.value)}
							invalid={Boolean(errors.newEmail)}
							feedback={errors.newEmail} />
					</FormGroup>
                </div>


                {#if saveError}
					<div class="alert alert-danger p-2">{saveError}</div>
				{/if}
				<div class="button-group mt-3">
					<button type="submit" class="btn btn-primary w-100" disabled={formHasErrors}>Update E-mail</button>
				</div>
            </form>
        </div>
    </div>
</main>

<Dialog bind:this={prompt} />
